// Author Shi Wen Long
// Date 2024-06-24 09:13:47

class SithMesStool26Stock {
constructor({
        id = null,
        material = '',
        materialType = '',
        date = '',
        mrpElement = '',
        mrpElementData = '',
        reschedulingDate = '',
        exception = '',
        reqdQty = '',
        availableQty = '',
        customer = '',
        customerName = '',
        vendor = '',
        vendorName = '',
        so = '',
        wbs = '',
        remark = ''}
= {}) {
    this.id = id;
    this.material = material;
    this.materialType = materialType;
    this.date = date;
    this.mrpElement = mrpElement;
    this.mrpElementData = mrpElementData;
    this.reschedulingDate = reschedulingDate;
    this.exception = exception;
    this.reqdQty = reqdQty;
    this.availableQty = availableQty;
    this.customer = customer;
    this.customerName = customerName;
    this.vendor = vendor;
    this.vendorName = vendorName;
    this.so = so;
    this.wbs = wbs;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesStool26Stock();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.stool.sithMesStool26Stock.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.stool.sithMesStool26Stock.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'status',
        label: 'label.sith.stool.sithMesStool26Stock.grid.status',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '商务未释放' },
                            { value: '2', text: '设计' },
                            { value: '3', text: '采购' },
                            { value: '4', text: '生产' },
                            { value: '5', text: '暂停' },
                            { value: '6', text: '寄存' },
                            { value: '7', text: '待发货' },
                            { value: '8', text: '已发出' }
            ]
                }
        },
        {
        key: 'material',
        label: 'label.sith.stool.sithMesStool26Stock.grid.material',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialDescriptionZH',
        label: 'label.sith.stool.sithMesStool26Stock.grid.materialDescriptionZH',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bunit',
        label: 'label.sith.stool.sithMesStool26Stock.grid.bunit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialType',
        label: 'label.sith.stool.sithMesStool26Stock.grid.materialType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'date',
        label: 'label.sith.stool.sithMesStool26Stock.grid.date',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mrpElement',
        label: 'label.sith.stool.sithMesStool26Stock.grid.mrpElement',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mrpElementData',
        label: 'label.sith.stool.sithMesStool26Stock.grid.mrpElementData',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'reschedulingDate',
        label: 'label.sith.stool.sithMesStool26Stock.grid.reschedulingDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'exception',
        label: 'label.sith.stool.sithMesStool26Stock.grid.exception',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'reqdQty',
        label: 'label.sith.stool.sithMesStool26Stock.grid.reqdQty',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'availableQty',
        label: 'label.sith.stool.sithMesStool26Stock.grid.availableQty',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'customer',
        label: 'label.sith.stool.sithMesStool26Stock.grid.customer',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'customerName',
        label: 'label.sith.stool.sithMesStool26Stock.grid.customerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'vendor',
        label: 'label.sith.stool.sithMesStool26Stock.grid.vendor',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'vendorName',
        label: 'label.sith.stool.sithMesStool26Stock.grid.vendorName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'so',
        label: 'label.sith.stool.sithMesStool26Stock.grid.so',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'wbs',
        label: 'label.sith.stool.sithMesStool26Stock.grid.wbs',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStool26Stock.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    projectCodeFilter : '',
    statusFilter : '',
    materialFilter : '',
    materialDescriptionZHFilter : '',
    bunitFilter : '',
    materialTypeFilter : '',
    dateFilter : '',
    mrpElementFilter : '',
    mrpElementDataFilter : '',
    reschedulingDateFilter : '',
    exceptionFilter : '',
    reqdQtyFilter : '',
    availableQtyFilter : '',
    customerFilter : '',
    customerNameFilter : '',
    vendorFilter : '',
    vendorNameFilter : '',
    soFilter : '',
    wbsFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.status',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '商务未释放' },
                { value: '2', text: '设计' },
                { value: '3', text: '采购' },
                { value: '4', text: '生产' },
                { value: '5', text: '暂停' },
                { value: '6', text: '寄存' },
                { value: '7', text: '待发货' },
                { value: '8', text: '已发出' }
            ]
        }
        },
        {
        key: 'materialFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.material',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialDescriptionZHFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.materialDescriptionZH',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bunitFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.bunit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialTypeFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.materialType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'dateFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.date',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mrpElementFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.mrpElement',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mrpElementDataFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.mrpElementData',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reschedulingDateFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.reschedulingDate',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'exceptionFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.exception',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reqdQtyFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.reqdQty',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'availableQtyFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.availableQty',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'customerFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.customer',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'customerNameFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.customerName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'vendorFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.vendor',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'vendorNameFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.vendorName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'soFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.so',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbsFilter',
        label: 'label.sith.stool.sithMesStool26Stock.filter.wbs',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'material',
        label: 'label.sith.stool.sithMesStool26Stock.entity.material',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialType',
        label: 'label.sith.stool.sithMesStool26Stock.entity.materialType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'date',
        label: 'label.sith.stool.sithMesStool26Stock.entity.date',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mrpElement',
        label: 'label.sith.stool.sithMesStool26Stock.entity.mrpElement',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mrpElementData',
        label: 'label.sith.stool.sithMesStool26Stock.entity.mrpElementData',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reschedulingDate',
        label: 'label.sith.stool.sithMesStool26Stock.entity.reschedulingDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'exception',
        label: 'label.sith.stool.sithMesStool26Stock.entity.exception',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reqdQty',
        label: 'label.sith.stool.sithMesStool26Stock.entity.reqdQty',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'availableQty',
        label: 'label.sith.stool.sithMesStool26Stock.entity.availableQty',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'customer',
        label: 'label.sith.stool.sithMesStool26Stock.entity.customer',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'customerName',
        label: 'label.sith.stool.sithMesStool26Stock.entity.customerName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'vendor',
        label: 'label.sith.stool.sithMesStool26Stock.entity.vendor',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'vendorName',
        label: 'label.sith.stool.sithMesStool26Stock.entity.vendorName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'so',
        label: 'label.sith.stool.sithMesStool26Stock.entity.so',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbs',
        label: 'label.sith.stool.sithMesStool26Stock.entity.wbs',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStool26Stock.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesStool26Stock, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
